import {NgModule} from "@angular/core";
import {IntSpinLoaderComponent} from "./int-spin-loader.component";
import {CommonModule} from "@angular/common";


@NgModule({
  declarations: [
    IntSpinLoaderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IntSpinLoaderComponent
  ]
})
export class IntSpinLoaderModule {}